import Swiper from "swiper/bundle";
import { closeModel } from "./modal-toggle";
import { lenis } from "../lenis";
import { zoomImg } from "./zoom";

let productSwiperInstance = null;
let productThumbsSwiperInstance = null;

export function loadProductModal(productId) {
  if (!productId) return;

  const fullImageAmbient = document.querySelector(".full-image-ambient");
  const closeBtn = document.querySelector(".ma-close");

  closeModel();
  document.body.classList.add("model-active-ambient", "model-active-promodel");
  lenis.stop();

  if (fullImageAmbient) {
    fullImageAmbient.innerHTML = '<div class="loading">Loading...</div>';

    fetch(`${nlTheme.ajaxurl}?action=get_product_modal&product_id=${productId}&lang=${nlTheme.lang}`)
      .then((res) => res.text())
      .then((html) => {
        fullImageAmbient.innerHTML = html;

        if (Swiper) {
          if (productSwiperInstance && productSwiperInstance.destroy) {
            productSwiperInstance.destroy(true, true);
            productSwiperInstance = null;
          }
          if (productThumbsSwiperInstance && productThumbsSwiperInstance.destroy) {
            productThumbsSwiperInstance.destroy(true, true);
            productThumbsSwiperInstance = null;
          }

          const mainSwiperContainer = fullImageAmbient.querySelector(".product-gallery-main");
          const thumbsSwiperContainer = fullImageAmbient.querySelector(".product-gallery-thumbs");

          if (mainSwiperContainer && thumbsSwiperContainer) {
            productThumbsSwiperInstance = new Swiper(thumbsSwiperContainer, {
              spaceBetween: 10,
              slidesPerView: "auto",
              freeMode: true,
              watchSlidesProgress: true,
            });

            productSwiperInstance = new Swiper(mainSwiperContainer, {
              loop: false,
              spaceBetween: 10,
              navigation: {
                nextEl: mainSwiperContainer.querySelector(".swiper-button-next"),
                prevEl: mainSwiperContainer.querySelector(".swiper-button-prev"),
              },
              thumbs: {
                swiper: productThumbsSwiperInstance,
              },
              on: {
                init: function () {
                  const activeSlide = this.slides[this.activeIndex];
                  if (activeSlide) {
                    const activeVideo = activeSlide.querySelector("video");
                    if (activeVideo) {
                      activeVideo.play().catch(err => {
                        console.warn("Video autoplay failed: ", err);
                      });
                    }
                  }
                },
                slideChange: function () {
                  const videos = mainSwiperContainer.querySelectorAll("video");
                  videos.forEach((video) => {
                    if (!video.paused) {
                      video.pause();
                    }
                  });

                  const activeSlide = this.slides[this.activeIndex];
                  if (activeSlide) {
                    const activeVideo = activeSlide.querySelector("video");
                    if (activeVideo) {
                      activeVideo.play().catch(err => {
                        console.warn("Video autoplay failed: ", err);
                      });
                    }
                  }
                }
              }
            });
          } else {
            const swiperContainer = fullImageAmbient.querySelector(".swiper");
            if (swiperContainer) {
              productSwiperInstance = new Swiper(swiperContainer, {
                loop: false,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                pagination: {
                  el: ".swiper-model-pagination",
                  clickable: true,
                },
              });
            }
          }
        }

        zoomImg();
      })
      .catch(() => {
        fullImageAmbient.innerHTML = '<div class="error">Failed to load product.</div>';
      });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      if (fullImageAmbient) {
        const videos = fullImageAmbient.querySelectorAll("video");
        videos.forEach((video) => {
          if (!video.paused) {
            video.pause();
          }
        });
        fullImageAmbient.innerHTML = "";
      }
      closeModel();
      lenis.start();
      // Remove product_id from URL
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.delete('product_id');
        url.search = params.toString();
        window.history.replaceState({}, '', url.toString());
      // Destroy swiper if exists
        if (productThumbsSwiperInstance && productThumbsSwiperInstance.destroy) {
            productThumbsSwiperInstance.destroy(true, true);
            productThumbsSwiperInstance = null;
        }
        if (productSwiperInstance && productSwiperInstance.destroy) {
            productSwiperInstance.destroy(true, true);
            productSwiperInstance = null;
        }
    });
  }
}


export function productModel() {
  const openBtns = document.querySelectorAll(".mp-open");

  if (openBtns.length) {
    openBtns.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const productId = btn.getAttribute("data-productid");

        // Change the URL with new product_id (no reload)
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.set('product_id', productId); // Add or update product_id
        url.search = params.toString();
        window.history.replaceState({}, '', url.toString());

        loadProductModal(productId);
      });
    });
  }
}
